import { render, staticRenderFns } from "./ModalCampaignDistributionErrored.vue?vue&type=template&id=f780460e&scoped=true"
import script from "./ModalCampaignDistributionErrored.vue?vue&type=script&lang=js"
export * from "./ModalCampaignDistributionErrored.vue?vue&type=script&lang=js"
import style0 from "./ModalCampaignDistributionErrored.vue?vue&type=style&index=0&id=f780460e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f780460e",
  null
  
)

export default component.exports